import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=3669d15c"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports